import { useTranslation } from "react-i18next";
import {
  FileDoneOutlined,
  CalculatorOutlined,
  SafetyCertificateOutlined,
  ThunderboltOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import { AUTH_CONTACT_NUMBER } from "./constants";

const FEATURES = [
  { icon: FileDoneOutlined, titleKey: "carousel1Title", descKey: "carousel1Desc" },
  { icon: CalculatorOutlined, titleKey: "carousel2Title", descKey: "carousel2Desc" },
  { icon: SafetyCertificateOutlined, titleKey: "carousel3Title", descKey: "carousel3Desc" },
  { icon: ThunderboltOutlined, titleKey: "carousel4Title", descKey: "carousel4Desc" },
];

const AuthBrandingPanel = () => {
  const { t } = useTranslation("auth");

  return (
    <div className="sm:flex hidden xl:w-4/6 min-w-[500px] bg-[#1677ff] text-white">
      <div className="w-full flex flex-col justify-center px-20 space-y-10">

        {/* Heading */}
        <div>
          <h2 className="text-2xl font-semibold leading-tight text-white">
            {t("heading")}
          </h2>

          <p className="mt-4 text-base text-blue-100 max-w-xl">
            {t("subheading")}
          </p>
        </div>

        {/* Features */}
        <div className="grid grid-cols-2 gap-6">
          {FEATURES.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <div
                key={index}
                className="bg-white/95 p-5 rounded-xl shadow-md hover:shadow-lg transition"
              >
                <div className="flex items-center gap-3">
                  <span className="text-[#1677ff] text-lg">
                    <IconComponent />
                  </span>
                  <h4 className="font-semibold text-base text-gray-800">
                    {t(feature.titleKey)}
                  </h4>
                </div>
                <p className="text-sm text-gray-600 mt-2">
                  {t(feature.descKey)}
                </p>
              </div>
            );
          })}
        </div>

        {/* Footer Contact */}
        <div className="pt-6">
          <div className="inline-flex items-center gap-3 bg-white/10 px-5 py-3 rounded-full text-white">
            <PhoneOutlined className="text-lg" />
            <span className="font-medium tracking-wide text-white">
              Contact Us: {AUTH_CONTACT_NUMBER}
            </span>
          </div>
        </div>

      </div>
    </div>
  );
};

export default AuthBrandingPanel;
